import { STRAPI_DEVELOPMENT, STRAPI_PRODUCTION } from "../../constants/Api";

function handleErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}

export const userTokenData = (access_token) => {
  return new Promise((resolve, reject) => {
    fetch(
      process.env.NODE_ENV === "production"
        ? `${STRAPI_PRODUCTION}/userInfo/${access_token}`
        : `${STRAPI_DEVELOPMENT}/userInfo/${access_token}`,
      {
        method: "GET",
      }
    )
      .then(handleErrors)
      .then(async (value) => value.json())
      .then((res) => {
        const { email } = res;
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
